<table mat-table [dataSource]="gridDataList" multiTemplateDataRows class="matTables productTable">
    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
        <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th></div>
        <div *ngIf="column=='detail'"><th mat-header-cell *matHeaderCellDef class="package">&nbsp;</th></div>
        <div *ngIf="column=='quantity'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Requested Quantity</th></div>
        <div *ngIf="column=='orderUOM'"><th mat-header-cell *matHeaderCellDef class="quantityBlock  text-center">Order UOM</th></div>
        <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Package Size</th></div>

        <td mat-cell *matCellDef="let element">
            <div *ngIf="column=='product'">
                <div class="order-info defaultCursor margin-l0">
                    <div class="d-block d-sm-block d-md-none">Product</div>
                    <p><span *ngIf="element.itemVendorName" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">{{element.itemVendorName}}</span> </p>
                    <p class="grower-name" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">{{element.productName}}</p>
                    <!--<p class="grower-name">{{element.itemNumber}}</p>-->
                </div>
            </div>
            <div *ngIf="column=='detail'" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED','showHideDetails text-center  m-center': element.lineStatus !=='CANCELLED' }">
                <!-- <div class="d-block d-sm-block d-md-none">&nbsp;</div> -->
                <ng-container *ngIf="element.lineStatus !=='CANCELLED';else elseBlock">
                    <a (click)="showProductDetails(element);" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">{{element.isDetailDisplayed ? 'Hide Product Details':'View Product Details' }}</a>
                </ng-container>
                <ng-template #elseBlock>
                    <ng-container class="text-center productDetailsFont m-center">View Product Details</ng-container>
                </ng-template>
            </div>
            <div *ngIf="column=='quantity'" class="text-center largeTableTxt mobile-col-set">
                <div class="d-block d-sm-block d-md-none">Requested Quantity</div>
                <div class="m-center">
                    <ng-container *ngIf="element.lineStatus !='CANCELLED'"> {{element.orderedQuantity}}</ng-container>
                    <ng-container *ngIf="element.lineStatus=='CANCELLED'" class="disabledrow">Cancelled</ng-container>
                </div>
            </div>
            <div *ngIf="column=='orderUOM'" class="text-center largeTableTxt mobile-col-set" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">
                <div class="d-block d-sm-block d-md-none">Order UOM</div> <div class="m-center">{{element.orderUOM}}</div>
            </div>
            <div *ngIf="column=='packageSize'" class="text-center largeTableTxt mobile-col-set" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">
                <div class="d-block d-sm-block d-md-none">Package Size</div> <div class="m-center">{{element.packageSize}}</div>
            </div>
        </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
        <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div [style.display]="element.isDetailDisplayed ? 'block' : 'none'">
                <div class="cpp-prod-info mobile-nested-table">
                    <table style="width:100%">
                        <tbody>
                            <tr class="xs-hide">
                                <th width="10%" class="text-left">Item Number </th>
                                <th width="10%"> GTIN </th>
                                <th width="15%"> Product Line </th>
                                <th width="25%"> Active Ingredients </th>
                                <th width="10%"> National Price </th>
                                <th width="11%"> Pallet Quantity </th>
                                <th width="10%"> Restricted Use </th>
                                <th width="6%"> Non-Returnable </th>
                            </tr>
                            <tr>
                                <th width="10%" class="d-block d-sm-block d-md-none">Item Number </th>
                                <td width="10%" class="text-left"><p>{{element.itemNumber}}</p> </td>

                                <th width="10%" class="d-block d-sm-block d-md-none"> GTIN </th>
                                <td width="10%"><p>{{element.gtin}}</p></td>

                                <th width="15%" class="d-block d-sm-block d-md-none"> Product Line </th>
                                <td width="15%"><p>{{element.productLine}}</p> </td>

                                <th width="25%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
                                <td width="25%"><p>{{element.activeIngredient}}</p> </td>

                                <th width="10%" class="d-block d-sm-block d-md-none"> National Price </th>
                                <td width="10%"><p *ngIf="element.price>0"> {{element.price | number:'1.4-4'}}/{{element.pricingUOM}}</p> </td>

                                <th width="11%" class="d-block d-sm-block d-md-none"> Pallet Quantity </th>
                                <td width="11%"><p>{{element.palletQuantity | number:'1.4-4'}}</p> </td>

                                <th width="10%" class="d-block d-sm-block d-md-none"> Restricted Use </th>
                                <td width="10%"><p>{{element.restrictedUse}}</p> </td>

                                <th width="6%" class="d-block d-sm-block d-md-none"> Non-Returnable </th>
                                <td width="6%"><div [ngClass]="{'oval-shape returnable':( element.returnable ==='X')}"><p>{{element.returnable}}</p></div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" [ngClass]="{ 'Cancelled': element.lineStatus =='CANCELLED' }"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
</table>
<div *ngIf="gridDataList == undefined || gridDataList?.length == 0" class="noDataMsg">
    <p>No Record Found.</p>
</div>
